import { gql } from '@apollo/client';

export default gql`
  mutation ToggleMediaItem(
    $courseId: String!
    $subjectId: String!
    $mediaItemId: String!
    $status: String!
  ) {
    mediaItem(
      courseId: $courseId
      subjectId: $subjectId
      mediaItemId: $mediaItemId
      status: $status
      input: {}
    )
      @rest(
        type: "MediaItem"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/videos/{args.mediaItemId}/{args.status}"
        method: "PUT"
      ) {
      _id
      enabled
    }
  }
`;
